import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Form } from "react-bootstrap";
import axios from "axios";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Header from "./../components/Header";
import LeftNav from "./../components/LeftNav";
import AskAthena from "../components/AskAthena";
import UserService from "../services/UserService";

const serverConfig = require("../config/server.js");

const Dashboard = () => {
  const navigate = useNavigate();

  const [token, setToken] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [viewReportsPrivileged, setViewReportsPrivileged] = useState(null);

  const [pinnedReport, setPinnedReport] = useState(false);
  const [iframeUrl, setIFrameUrl] = useState(null);
  const [iframeName, setIFrameName] = useState(null);
  const [dashboardList, setDashboardList] = useState([]);
  // Raw, un-scoped, client-wide deployed rows (every real subscriber, not just
  // the viewer) -- used ONLY by the admin "Filter by User" control.
  // dashboardList itself is always the viewer's OWN deployed products.
  const [allClientDeployedItems, setAllClientDeployedItems] = useState([]);
  const [dashboardListFinal, setDashboardListFinal] = useState([]);
  const [modulesSubscribed, setModulesSubscribed] = useState({});
  const [productsDeployed, setProductsDeployed] = useState({});
  const [selectFunctions, setSelectFunctions] = useState([]);
  const [functions, setFunctions] = useState([]);
  const [deployedFunctionList, setDeployedFunctionList] = useState([]);
  const [refreshNotifications, setRefreshNotifications] = useState(false);
  const [userList, setUserList] = useState([]);
  const selectedFunctionRef = useRef(null);
  const [defaultFunctionFilter, setDefaultFunctionFilter] = useState(null);

  const handleLogout = () => {
    sessionStorage.clear();
    UserService.doLogout();
  };

  const getToken = () => {
    console.log(sessionStorage.getItem("token"));
    let jwt = UserService.getToken();
    axios
      .post(serverConfig.api_base_url + "user_get_token", { jwt: jwt })
      .then((response) => {
        console.log("user_get_token response", response);
        if (response.data.status === 200) {
          sessionStorage.setItem("token", response.data.token);
          setToken(response.data.token);
        } else if (response.data.status >= 400 && response.data.status <= 499) {
          alert(response.data.message);
        } else if (response.data.jwt_validation === "fail") {
          handleLogout();
        }
      })
      .catch((err) => console.log("error is", err));
  };

  useEffect(() => {
    console.log(sessionStorage.getItem("token"));
    if (sessionStorage.getItem("token") === null) {
      getToken();
    } else {
      setToken(sessionStorage.getItem("token"));
    }
  }, []);

  useEffect(() => {
    if (token !== null && token !== undefined) {
      axios
        .post(serverConfig.api_base_url + "user_check_privilege", {
          token: token,
          privilege: "view_reports",
        })
        .then((response) => {
          console.log("user_check_privilege response", response.data);
          if (response.data.status === 200) {
            if (response.data.is_privileged === 1) {
              setViewReportsPrivileged(true);
            } else if (response.data.is_privileged === 0) {
              setViewReportsPrivileged(false);
            }
          } else if (response.data.status === 301) {
            handleLogout();
          } else {
            alert(response.data.message);
          }
        })
        .catch((err) => console.log("error is", err));

      axios
        .post(serverConfig.api_base_url + "modules_subscribed_get", {
          token: token,
        })
        .then((response) => {
          console.log("modules_subscribed_get response", response.data.items);
          if (response.data.status === 200) {
            if (response.data.items !== null) {
              setFunctions(response.data.items);
            }
          } else if (response.data.status === 301) {
            handleLogout();
          } else {
            alert(response.data.message);
          }
        })
        .catch((err) => console.log("error is", err));

      axios
        .post(serverConfig.api_base_url + "lookup_list", {
          name: "select_functions",
          token: token,
        })
        .then((response) => {
          console.log("lookup_list_response response", response.data.items);
          if (response.data.status === 200) {
            if (response.data.items !== null) {
              response.data.items.sort(function (a, b) {
                return a.seq_no - b.seq_no;
              });
              setSelectFunctions(response.data.items);
            }
          } else if (response.data.status === 301) {
            handleLogout();
          } else {
            alert(response.data.message);
          }
        })
        .catch((err) => console.log("error is", err));
    }
  }, [token]);

  // Rebuilds the base list, function chips, and default function+display for
  // whichever email is currently being viewed -- the viewer's own by default,
  // or a specifically-selected other person via "Filter by User". Shared by
  // the initial load and handleFilterByUser so both stay in sync: switching
  // users updates the available function chips too, not just the product list.
  const applyUserView = (rawItems, email, { preserveFunctionRef = false } = {}) => {
    const userItems = rawItems.filter((el) => el.email_id === email);
    setDashboardList(userItems);

    setDeployedFunctionList([
      ...new Set(userItems.map((item) => item.function_name)),
    ]);

    const firstFunction = [...userItems]
      .sort((a, b) => a.seq_no - b.seq_no)
      .map((item) => item.function_name)[0];
    const pinnedItem = userItems.find((el) => el.pinned === 1);
    const defaultFunction = pinnedItem ? pinnedItem.function_name : firstFunction;

    if (preserveFunctionRef) {
      if (!selectedFunctionRef.current) {
        setDefaultFunctionFilter(defaultFunction);
      }
    } else {
      selectedFunctionRef.current = null;
      setDefaultFunctionFilter(defaultFunction);
    }
    const functionToShow =
      (preserveFunctionRef && selectedFunctionRef.current) || defaultFunction;
    setDashboardListFinal(
      userItems.filter((el) => el.function_name === functionToShow)
    );
  };

  useEffect(() => {
    if (token !== null && token !== undefined && selectFunctions.length > 0) {
      axios
        .post(serverConfig.api_base_url + "dashboard_list_get", {
          token: token,
        })
        .then((response) => {
          console.log("dashboard_list_get response", response);
          if (response.data.status === 200) {
            if (response.data.items !== null) {
              // dashboard_list_get returns one row per (product, real subscriber).
              // The default view -- page load, and clicking a Filter by Function
              // chip -- is ALWAYS the viewer's own deployed products, admin or
              // not. Only the admin-only "Filter by User" control explicitly
              // shows a different, specifically-selected person's rows (via
              // allClientDeployedItems, the raw/un-scoped list kept alongside).
              const myEmail = UserService.getUsername();
              const rawDeployed = response.data.items.filter(
                (el) => el.is_deployed === 1
              );
              setAllClientDeployedItems(rawDeployed);
              setUserList([
                ...new Set(rawDeployed.map((item) => item.email_id)),
              ]);

              const myDeployed = rawDeployed.filter(
                (el) => el.email_id === myEmail
              );
              applyUserView(rawDeployed, myEmail, { preserveFunctionRef: true });

              //setModulesSubscribed(response.data.modules_subscribed);
              //setProductsDeployed(response.data.bi_products_deployed);
              let pinned = myDeployed.filter((el) => el.pinned === 1);
              if (pinned.length > 0) {
                if (pinned[0].is_deployed === 1) {
                  setIFrameUrl(pinned[0].link);
                }
                //setIFrameName(pinned[0].product_name);
              } else if (myDeployed[0]) {
                setIFrameUrl(myDeployed[0].link);
                //setIFrameName(myDeployed[0].product_name);
              }
              setIsLoading(false);
            } else {
              setDashboardList([]);
              setDashboardListFinal([]);
              //setModulesSubscribed({});
              //setProductsDeployed({});
              setIsLoading(false);
            }
          } else if (response.data.status === 301) {
            handleLogout();
          } else {
            alert(response.data.message);
            setIsLoading(false);
          }
        })
        .catch((err) => console.log("error is", err));
    }
  }, [token, selectFunctions, pinnedReport]);

  const handleReportPin = (productid, toPin) => {
    axios
      .post(serverConfig.api_base_url + "report_pin", {
        token: token,
        product_id: productid,
        to_pin: toPin,
      })
      .then((response) => {
        setIsLoading(true);
        console.log("report_pin response:", response);
        if (response.data.status === 200) {
          console.log("success");
          setPinnedReport(!pinnedReport);
        } else if (response.data.status === 301) {
          handleLogout();
        } else {
          alert(response.data.message);
          setIsLoading(false);
        }
      })
      .catch((err) => console.log("error is", err));
  };

  const handleFunctionsCheck = (event) => {
    console.log(event.target.value);
    console.log(dashboardList);
    console.log(
      dashboardList.filter((el) => el.function_name === event.target.value)
    );
    console.log(dashboardListFinal);
    selectedFunctionRef.current = event.target.value;
    setDashboardListFinal(
      dashboardList.filter((el) => el.function_name === event.target.value)
    );
  };

  const handleFilterByUser = (event) => {
    const email =
      event.target.value !== "" && event.target.value !== null
        ? event.target.value
        : UserService.getUsername();
    applyUserView(allClientDeployedItems, email);
  };

  const extractUrlFromLink = (link) => {
    if (!link) return null;
    try {
      const urlPart = link.split(" ").find((el) => el.startsWith("src="));
      if (urlPart) {
        return urlPart.slice(5).slice(0, -1);
      }
    } catch (e) {
      console.error("Error extracting URL from link:", e);
    }
    return null;
  };

  const handleProductClick = (item) => {
    // Update iframe (current behavior)
    setIFrameUrl(item.link);
    // Open in new tab (like popout button)
    const url = extractUrlFromLink(item.link);
    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  const responsive = {
    xl: {
      breakpoint: { max: 2160, min: 1280 },
      items: 6,
    },
    lg: {
      breakpoint: { max: 1280, min: 1024 },
      items: 4,
    },
    md: {
      breakpoint: { max: 1024, min: 768 },
      items: 3,
    },
    sm: {
      breakpoint: { max: 768, min: 640 },
      items: 2,
    },
    xs: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
    },
  };

  return (
    <>
      <LeftNav />
      <div className="main-wrapper">
        <Header token={token} refreshNotifications={refreshNotifications} />
        <div className="d-flex content-wrap">
          <main>
            {isLoading && (
              <div id="loading">
                <img
                  src={require("./../assets/images/icons/spinner.gif")}
                  alt="Loader"
                  width="70"
                />
              </div>
            )}
            <Container fluid>
              {/* {iframeUrl && <section className="iframe-wrapper" dangerouslySetInnerHTML={{__html: iframeUrl}} />} */}
              {iframeUrl && (
                <div className="position-relative">
                  <section
                    className="iframe-wrapper"
                    dangerouslySetInnerHTML={{ __html: iframeUrl }}
                  />
                  <a
                    href={iframeUrl
                      .split(" ")
                      .find((el) => el.startsWith("src="))
                      .slice(5)
                      .slice(0, -1)}
                    target="_blank"
                    style={{
                      position: "absolute",
                      right: "5px",
                      bottom: "5px",
                    }}
                    title="Open in new tab"
                  >
                    <img
                      src={require("./../assets/images/icons/arrow-up-right-from-square.png")}
                      width="20"
                    />
                  </a>
                </div>
              )}

              {dashboardListFinal.length > 0 && (
                <section className="bg-dark-gray mb-0">
                  <Carousel responsive={responsive} className="reports-list">
                    {dashboardListFinal.map((item, index) => {
                      return (
                        /* functions.some(el => el.function === item.function_name) && */ <div
                          xs="auto"
                          key={index}
                        >
                          <div
                            className={
                              item.pinned === 1 ? "item active" : "item"
                            }
                            onClick={() => handleProductClick(item)}
                          >
                            {item.pinned === 1 ? (
                              <img
                                src={require("./../assets/images/icons/star-icon.png")}
                                alt="Pin"
                                width="12"
                                title="Remove from favourites"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleReportPin(item.product_id, 0);
                                }}
                              />
                            ) : (
                              <img
                                src={require("./../assets/images/icons/star-empty-icon.png")}
                                alt="Pin"
                                width="12"
                                title="Add to favourites"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleReportPin(item.product_id, 1);
                                }}
                              />
                            )}
                            <div>
                              <img
                                src={item.icon && item.icon}
                                alt={item.value}
                                width="50"
                              />
                            </div>
                            <span>{item.product_name}</span>
                          </div>
                        </div>
                      );
                    })}
                  </Carousel>
                </section>
              )}

              {deployedFunctionList.length > 0 && defaultFunctionFilter && (
                <section className="client-subscription mt-0 mb-0">
                  <h6>Filter{!viewReportsPrivileged && <> by Function</>}</h6>
                  <Carousel key={defaultFunctionFilter} responsive={responsive} className="subscription">
                    {deployedFunctionList.map((functionName, index) => {
                      const iconMatch = selectFunctions.find(
                        (sf) => sf.value === functionName
                      );
                      return (
                        <div key={index} className="label-wrap">
                          <label htmlFor={functionName}>
                            <input
                              name="functions"
                              type="radio"
                              id={functionName}
                              value={functionName}
                              onChange={handleFunctionsCheck}
                              /* onClick={(e) => e.stopPropagation()} */ defaultChecked={
                                functionName === (defaultFunctionFilter || deployedFunctionList[0])
                              }
                            />
                            <span className="image">
                              {iconMatch?.attribute1 && (
                                <img
                                  src={iconMatch.attribute1}
                                  alt={functionName}
                                  width="50"
                                />
                              )}
                            </span>
                            <span className="text">{functionName}</span>
                          </label>
                        </div>
                      );
                    })}
                  </Carousel>

                  {!viewReportsPrivileged && (
                    <div className="mt-4">
                      <h6>Filter by User</h6>
                      {userList.length > 0 && (
                        <Form.Select
                          style={{ width: "300px" }}
                          onChange={handleFilterByUser}
                        >
                          <option value="">Select User</option>
                          {userList.map(
                            (usr, isridx) =>
                              usr && <option value={usr}>{usr}</option>
                          )}
                        </Form.Select>
                      )}
                    </div>
                  )}
                </section>
              )}
            </Container>
          </main>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
